import {combineReducers} from 'redux';
import {composeReducers} from 'common/utils/reducers';
import data from './dataReducer';
import views from './viewsReducer';
import * as actions from '../actions';

const root = combineReducers({
  views,
  data,
});

export default composeReducers(root, (state, action) => {
  if (action.type === actions.resetAlertsConsole.TYPE) {
    return root(undefined, {type: 'no-action'});
  }
  return state;
});
